var map = {
	"./0100/2x1/10.jpg": "1A1S",
	"./0100/3x1/10.jpg": "3qd7",
	"./0100/4x1/10.jpg": "EeML",
	"./0480/2x1/10.jpg": "CN3W",
	"./1200/3x1/10.jpg": "IY8m",
	"./1920/4x1/10.jpg": "ZnK5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UghV";